import gsap from 'gsap'
import Lenis from 'lenis'
import ScrollTrigger from 'gsap/ScrollTrigger'

export const lenisEase = {
  power3inOut: (t) => (t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2),
  power4inOut: (t) => (t < 0.5 ? 8 * t ** 4 : 1 - (-2 * t + 2) ** 4 / 2),
}

export let lenisInstance = null

export const LenisScroll = {
  init(mode: 'gsap' | 'default' = 'gsap', options = undefined): void {
    lenisInstance = new Lenis({
      lerp: 0.1,
      ...options,
    })

    mode === 'gsap' ? this.gsapMode() : this.defaultMode(lenisInstance)
  },

  // Standard approach
  defaultMode(target): void {
    function raf(time) {
      target.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  },

  // GSAP approach - better performance & no lags with ScrollTriggers & pinned containers
  gsapMode(): void {
    gsap.registerPlugin(ScrollTrigger)
    lenisInstance.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenisInstance.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  },
}
